/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {COLORS} from "@res/colors";
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {AlertsModule, OnAlertsUpdated} from "@modules/AlertsModule";
import * as emotion from "emotion";
import {hideTooltip, showTooltipAtXY} from "../../widget/appTooltip";
import {OnTimeFilterChanged} from "@modules/UserPreferencesModule";
import {FONTS} from "@res/fonts";
import {AlertHover} from "../../../utils/AlertHover";
import {Second} from "@intuitionrobotics/ts-common";
import {DB_Patient} from "@app/app-shared/patient";

const AlertButtonCSS = emotion.css(
    {
        color: COLORS.white,
        minWidth: 58,
        height: 26,
        textAlign: 'center',
        borderRadius: 4,
        backgroundColor: COLORS.macaroni_and_cheese,
        ':hover': {
            boxShadow: 'rgb(236 236 236) 0px 0px 3px 1px'
        }
    }
);

type AlertButtonProps = {
    onClick?: () => void
    patient: DB_Patient
}

type AlertButtonState = {}

export class AlertButton
    extends BaseComponent<AlertButtonProps, AlertButtonState>
    implements OnAlertsUpdated, OnTimeFilterChanged {

    __onAlertsUpdated() {
        this.forceUpdate();
    }

    __onTimeFilterChanged() {
        this.forceUpdate();
    }

    render() {
        const patient = this.props.patient;
        const patientAlerts = AlertsModule.getUnresolvedPatientAlerts(patient._id);

        if (!patientAlerts || !patientAlerts.length)
            return null;

        const buttonText = `${patientAlerts.length} Notification${patientAlerts.length > 1 ? 's' : ''}`;

        return <div
            className={`${AlertButtonCSS} clickable ll_h_c`}
            style={{justifyContent: 'center', paddingLeft: '3px', paddingRight: '3px'}}
            onClick={() => {
                this.props.onClick?.();
            }}
            onMouseEnter={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = rect.x + rect.width / 2;
                const y = rect.y + rect.height + 10;
                showTooltipAtXY(
                    <AlertHover alerts={patientAlerts} patient={patient?._id}/>,
                    x, y,
                    {padding: 10, backgroundColor: COLORS.white, transform: 'translate(-50%)', border: `1px solid ${COLORS.primary_light_blue}`, textAlign: "left"},
                    3600 * Second
                );
            }}
            onMouseLeave={hideTooltip}
        >
            {FONTS.reg_11_white(buttonText)}
        </div>;
    }
}
